<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb"></breadcrumb>
    <div v-loading="loading">
      <div class="button_wrap">
        <span
          ><h4>{{ language("shopCategory.breadcrumbTitle") }}</h4></span
        >
        <template v-if="$menuList['SIS-ShopDisplay-Category-Add']">
          <el-button type="primary" @click="open">{{
            language("shopCategory.add")
          }}</el-button>
        </template>
      </div>
      <el-divider></el-divider>
      <div class="count_tips">
        <div>
          {{ language("shopCategory.results") }} {{ results }}
          {{ language("shopCategory.rows") }}
        </div>
        <page :total="results" @pageChange="pageChange"></page>
      </div>
      <cc-table
        :loadData="false"
        :config="table"
        :dataArr="dataArr"
        :params="params"
        :refeshParams="refeshTable"
        :showIndex="false"
        :buttonsWidth="buttonsWidth"
        :emptyText="language('shopCategory.emptyText')"
      ></cc-table>
    </div>

    <template v-if="dialog">
      <el-dialog
        :title="language('shopCategory.breadcrumbTitle')"
        :visible.sync="dialog"
        :close-on-click-modal="false"
        width="90%"
      >
        <category-edit :editData="editData" @success="success"></category-edit>
      </el-dialog>
    </template>
  </div>
</template>
<script>
import breadcrumb from "../../components/breadcrumb";
import page from "../../components/page";
import categoryEdit from "./components/categoryEdit";
export default {
  components: {
    breadcrumb,
    categoryEdit,
    page,
  },
  data() {
    return {
      loading: false,
      breadcrumb: {
        title: this.language("shopCategory.breadcrumbTitle"),
        list: [
          {
            name: this.language("shopCategory.breadcrumbList_1"),
          },
          {
            name: this.language("shopCategory.breadcrumbList_2"),
          },
        ],
      },
      table: {
        api: "admin/merchant/category/rel/query",
        showPager: false,
        columns: [
          // {
          //   prop: "id",
          //   lable: "ID",
          // },
          // {
          //   prop: "code",
          //   minWidth: 50,
          //   lable: this.language("shopCategory.code"),
          // },
          {
            prop: "sort",
            lable: this.language("shopCategory.sort"),
            minWidth: 80,
          },
          {
            prop: "name",
            lable: this.language("shopCategory.nameChi"),
            minWidth: 100,
          },
          {
            prop: "nameEn",
            lable: this.language("shopCategory.nameEng"),
            minWidth: 100,
          },
          {
            prop: "code",
            minWidth: 50,
            lable: this.language("shopCategory.code"),
          },
          // {
          //   prop: "cateType",
          //   lable: this.language("shopCategory.cateType"),
          // },
          {
            prop: "parentId",
            lable: this.language("shopCategory.parentId"),
            minWidth: 80,
            render:rows=>{
              if(rows.parentId){
                return rows.parentId
              }
              return ""
            }
          },
           {
            prop: "parentName",
            lable: this.language("shopCategory.parentName"),
            minWidth: 80,
            render:rows=>{
              if(rows.parentName==""){
                return "頂級"
              }
              return rows.parentName
            }
          },

          {
            prop: "isShow",
            lable: this.language("shopCategory.isShow"),

            type: "tag",
            options: {
              1: {
                tagType: "success",
                text: this.language("shopCategory.visible"),
              },
              0: {
                tagType: "danger",
                text: this.language("shopCategory.invisible"),
              },
            },
          },

          {
            prop: "status",
            lable: this.language("shopCategory.displayed"),

            type: "tag",
            options: {
              1: {
                tagType: "success",
                text: this.language("shopCategory.visible"),
              },
              0: {
                tagType: "danger",
                text: this.language("shopCategory.invisible"),
              },
              2: {
                tagType: "danger",
                text: this.language("shopCampaign.forbidden"),
              },
            },
          },
        ],
        buttons: [],
      },
      params: {},
      refeshTable: -1,
      dialog: false,
      dataArr: [],
      results: 0,
      editData: {},
      form: {
        pageSize: 10,
        pageNo: 1,
      },
      buttonsWidth: 0,
    };
  },
  methods: {
    open() {
      this.dialog = true;
      this.editData = {};
    },
    pageChange(e) {
      this.form.pageSize = e.pageSize;
      this.form.pageNo = e.pageNo;
      this.getData(this.form);
    },
    getData(e) {
      this.loading = true;
      e.shopNum = this.$shopData.shopNum;
      e.mchShopNum = this.$shopData.shopNum;
      this.ccRequest
        .do("admin/merchant/category/query", e)
        .then((res) => {
          this.dataArr = res.rows;
          this.results = res.total;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.$message.error(err.response.data.message);
        });
    },
    success() {
      this.getData(this.form);
    },
    delete(row) {
      this.$confirm(
        this.language("common.deletePermanentTips"),
        this.language("common.tips"),
        {
          confirmButtonText: this.language("common.confirm"),
          cancelButtonText: this.language("common.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.ccRequest
            .do(
              "admin/merchant/category/batchDelete",
              {
                ids: [row.id],
              },
              "POSTJSON"
            )
            .then((res) => {
              this.$message({
                type: "success",
                message: this.language("shopBannerForm.success"),
              });
              this.getData(this.form);
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.shopData = this.$shopData;
    this.getData({
      pageSize: 10,
      pageNo: 1,
    });
    if (this.$menuList["SIS-ShopDisplay-Category-Edit"]) {
      this.table.buttons.push({
        name: this.language("shopCategory.edit"),
        click: (row, index) => {
          this.editData = { ...row };
          this.editData.parentId = this.editData.parentId + "";
          this.dialog = true;
        },
      });
      this.buttonsWidth = 80;
    }
    if (this.$menuList["SIS-ShopDisplay-Category-Delete"]) {
      this.table.buttons.push({
        name: this.language("shopCategory.delete"),
        click: (row, index) => {
          this.delete(row);
        },
      });
      this.buttonsWidth = 80;
    }
  },
};
</script>
<style >
</style>
<style scoped lang="scss">
.button_wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.count_tips {
  margin: 10px 0 20px 0;
  display: flex;
  justify-content: space-between;
  // font-size: $sbuTitle;
  font-weight: 600;
}
</style>